//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';
import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getAllSelectedContent = createSelector(
  (state: ICuralateStore) =>
    state.galleries.addToGalleriesModal.currentlySelectedItems,
  (selectedItemsByCuid) => PojoMap.values(selectedItemsByCuid),
);
